/**
 * A URL-safe fragment for a map node's id, derived from its label. Formatting
 * only: nothing reads a slug back to work out what it names.
 */
export function mapSlug(value: string): string {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}
